import { Schema } from 'effect';

/**
 * Every side a parameter can apply to, as the engine names them.
 *
 * Which way round a fitting goes: `V` and `H` are left and right, `T` and `B` the top and bottom, and the `I`/`U` on the end of most of them is the inside or the outside. `F` and `X` stand apart — `F` is the whole thing, `X` is none of it.
 *
 * Read off `/configurator/configuration-sides`, which is the engine publishing the list as a resource of its own. Copied here rather than fetched, for the same reason {@link ComponentTypes} is copied: the copy is meant to fail. A side the engine sends and this list does not have means the two have drifted, and the
 * configuration carrying it refuses to decode — in test, on the first configuration that uses it, rather than as a control that quietly shows the wrong side.
 *
 * Kept in the order the endpoint answers with rather than sorted, so the two can be read side by side the day one of them changes.
 */
export const SideTypes = Schema.Literals(['VI', 'VU', 'HI', 'HU', 'TI', 'TU', 'BI', 'BU', 'F', 'V', 'H', 'T', 'X', 'XI', 'XU', 'VX', 'HX']);

/** One of the sides a parameter can apply to. */
export type ISideType = typeof SideTypes.Type;
